<template>
  <Layout>
    <PageHeader :title="'Onaydaki Cariler'" :items="breadcrumbArray"></PageHeader>
    <v-app>
      <v-card>
        <v-card-text>
          <b-table
              :items="currentApprovalList"
              :fields="currentApprovalListHeaders"
              hover
              responsive
              sort-icon-left
              :per-page="perPage"
              :busy="currentApprovalListLoading"
              @sort-changed="sortChanged"
          >
            <template #cell(authorizeFirstName)="data">
              {{ data.item.authorizeFirstName + ' ' + data.item.authorizeLastName }}
            </template>
            <template #cell(city)="data">
              {{ data.item.city + ' ' + data.item.town }}
            </template>
            <template #cell(process)="data">
              <div class="text-center">
                <v-tooltip top>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                        v-bind="attrs"
                        v-on="on"
                        icon
                        color="indigo darken-2"
                        @click="currentAdminApprove({
                          params:{
                            openCurrentId: data.item.id,
                            userId: user.UserId
                          },
                          body:{

                          }
                        })"
                    >
                      <v-icon>mdi-check</v-icon>
                    </v-btn>
                  </template>
                  <span>Admin Onayı</span>
                </v-tooltip>
                <v-tooltip top>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                        v-bind="attrs"
                        v-on="on"
                        icon
                        color="success darken-2"
                        @click="currentAccountingApprove({
                          params:{
                            openCurrentId: data.item.id,
                            userId: user.UserId
                          },
                          body:{

                          }
                        })"
                    >
                      <v-icon>mdi-check</v-icon>
                    </v-btn>
                  </template>
                  <span>Kullanıcı Onayı</span>
                </v-tooltip>
                <v-tooltip top>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                        v-bind="attrs"
                        v-on="on"
                        icon
                        color="danger darken-2"
                        @click="currentReject({
                          params:{
                            openCurrentId: data.item.id,
                            userId: user.UserId
                          },
                          body:{

                          }
                        })"
                    >
                      <v-icon>mdi-close</v-icon>
                    </v-btn>
                  </template>
                  <span>Reddet</span>
                </v-tooltip>
              </div>
            </template>
            <template #table-busy>
              <div class="text-center">
                <b-spinner
                    variant="primary"
                    size="lg"
                    label="Text Centered"
                ></b-spinner>
              </div>
            </template>
          </b-table>
        </v-card-text>
      </v-card>


    </v-app>

  </Layout>
</template>




<script>
import Layout from "@/pages/layout/main.vue";
import PageHeader from "@/components/page-header";
import { mapState, mapMutations, mapGetters, mapActions } from "vuex";
import {swalToast} from "@/helpers/swalToast";


export default {
  page: {
    title: "Onaydaki Cariler",
    meta: [{ name: "description", content: "Onaydaki Cariler" }],
  },
  props: {
    perPage: {
      type: Number,
    },
    currentPage: {
      type: Number,
    },
  },
  components:{
    Layout,
    PageHeader
  },
  computed: {
    ...mapState("current", [
      "currentApprovalList",
      "currentApprovalListHeaders",
      "currentApprovalListLoading",
    ]),
    ...mapState("auth",["user"]),
    ...mapGetters("current", ["getCurrent"]),
    current: {
      get() {
        return this.getCurrent;
      },
      set(value) {
        if (value) {
          swalToast.fire({
            title: "",
            text: "Cari : " + value.title + " seçildi",
            iconColor: 'green',
          });
        }
        this.setCurrent(value);
      },
    },
  },
  mounted(){
    this.fetchCurrentApprovalList({
      params:{
        userId: this.user.UserId
      },
      body:{

      }
    })
  },
  data() {
    return {
      selectRow: false,
      showCurrentStockActionsDialog: false,
      showCurrentActionsDialog: false,
      showCurrentUnclosedInvoicesDialog: false,
      currentStockActionsProp: null,
      currentActionsProp: null,
      currentUnclosedInvoicesProp: null,
      breadcrumbArray: [
        {
          text: "Cari",
          active: false,
        },
        {
          text: "Onaydaki Carileri",
          active: true,
        },
      ],
    };
  },
  methods: {
    ...mapMutations("current", ["setCurrent"]),
    ...mapActions("current", ["fetchCurrentApprovalList","currentAdminApprove","currentAccountingApprove","currentReject"]),
    sortChanged(value){
      value;
    },
    openCurrentStockActionsDialog(data) {
      this.currentStockActionsProp = data;
      this.showCurrentStockActionsDialog = true;
    },
    openCurrentActionsDialog(data) {
      this.currentActionsProp = data;
      this.showCurrentActionsDialog = true;
    },
    openCurrentUnclosedInvoicesDialog(data) {
      this.currentUnclosedInvoicesProp = data;
      this.showCurrentUnclosedInvoicesDialog = true;
    }
  },
  watch: {

  },
};
</script>
